import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

const OnboardingForm = ({ stripeConnect }) => {
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();

  const handleStartOnboarding = async () => {
    try {
      setIsLoading(true);
      const { error } = await stripeConnect.open({
        type: 'account_onboarding',
        account: stripeConnect.accountId,
      });

      if (error) {
        console.error('Error starting onboarding:', error);
        // Handle error appropriately
      } else {
        // Onboarding started successfully
        // The user will be redirected back to the success URL
      }
    } catch (err) {
      console.error('Error:', err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="space-y-6">
      <div className="bg-gray-50 p-6 rounded-lg">
        <h2 className="text-lg font-medium text-gray-900 mb-4">
          Required Information
        </h2>
        <ul className="space-y-2 text-sm text-gray-600">
          <li className="flex items-center">
            <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Business details and contact information
          </li>
          <li className="flex items-center">
            <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Bank account for receiving payments
          </li>
          <li className="flex items-center">
            <svg className="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Identity verification
          </li>
        </ul>
      </div>

      <div className="flex justify-center">
        <button
          onClick={handleStartOnboarding}
          disabled={isLoading}
          className={`w-full sm:w-auto px-6 py-3 rounded-md text-white font-medium
            ${isLoading 
              ? 'bg-gray-400 cursor-not-allowed' 
              : 'bg-brand-teal hover:bg-brand-teal-dark'
            } transition-colors duration-200`}
        >
          {isLoading ? (
            <span className="flex items-center">
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
              Processing...
            </span>
          ) : (
            'Start Verification'
          )}
        </button>
      </div>
    </div>
  );
};

export default OnboardingForm; 